<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'next/icon/Icon.vue';
import MessageStatus from './MessageStatus.vue';
import { useMessageDeliveryStatus } from './useMessageDeliveryStatus';
import { MESSAGE_STATUS } from './constants';

const props = defineProps({
  delivery: { type: Object, default: null },
  canViewDetails: { type: Boolean, default: false },
});
const emit = defineEmits(['details']);
const { t } = useI18n();
const { showStatusIndicator, statusToShow } = useMessageDeliveryStatus();
const visible = computed(() => showStatusIndicator.value || props.delivery);
const warning = computed(
  () =>
    props.delivery?.warning ||
    (showStatusIndicator.value && statusToShow.value === MESSAGE_STATUS.UNKNOWN)
);
const label = computed(() => {
  if (props.delivery) return props.delivery.text;
  const labels = {
    [MESSAGE_STATUS.SENT]: t('CHAT_LIST.SENT'),
    [MESSAGE_STATUS.DELIVERED]: t('CHAT_LIST.DELIVERED'),
    [MESSAGE_STATUS.READ]: t('CHAT_LIST.MESSAGE_READ'),
    [MESSAGE_STATUS.PROGRESS]: t('CHAT_LIST.SENDING'),
  };
  return statusToShow.value === MESSAGE_STATUS.UNKNOWN
    ? '投递待核对，请勿重复发送'
    : labels[statusToShow.value];
});

function openDetails() {
  if (props.canViewDetails) emit('details');
}
</script>

<template>
  <div
    v-if="visible"
    data-whatsapp-delivery
    class="mt-1 flex flex-col items-end max-w-full"
  >
    <component
      :is="canViewDetails ? 'button' : 'span'"
      v-tooltip.top-start="label"
      :type="canViewDetails ? 'button' : undefined"
      :role="canViewDetails ? undefined : 'img'"
      :aria-label="`消息状态：${label}`"
      :aria-haspopup="canViewDetails ? 'dialog' : undefined"
      :class="warning ? '!text-n-amber-11' : ''"
      class="!inline-flex items-center justify-center size-6 !p-0 !bg-transparent hover:!bg-n-alpha-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-blue-9"
      @click.stop="openDetails"
    >
      <MessageStatus
        v-if="showStatusIndicator"
        :status="statusToShow"
        :show-tooltip="false"
      />
      <Icon
        v-else
        :icon="
          delivery.warning ? 'i-lucide-triangle-alert' : 'i-lucide-history'
        "
        :class="delivery.warning ? 'text-n-amber-11' : 'text-n-slate-10'"
        class="size-[14px]"
      />
    </component>
  </div>
</template>
